module.exports = __webpack_public_path__ + "static/media/rabbit-line-pay-logo.4172b5d5.png";